import { HttpClient, HttpHeaders } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { Observable, of } from 'rxjs';
import { GradeLibraryVersion } from '../interfaces/grade-library-version';
import { catchError, map } from 'rxjs/operators';

@Injectable({ providedIn: 'root' })
export class GradeLibraryService {

	constructor(private httpClient: HttpClient) { }

	public getVersion(): Observable<GradeLibraryVersion | null> {
		return this.httpClient.get<GradeLibraryVersion>('/api/datamanagement/gradelibrary/version')
			.pipe(
				map((version: GradeLibraryVersion) => {
					return this.parseVersion(version);
				}),
				catchError(() => {
					return of(null);
				})
			);
	}	

	public parseVersion(version: GradeLibraryVersion): GradeLibraryVersion {
		return {
			version: version.version,
			timestamp: new Date(version.timestamp).toUTCString()
		};
	}

	public uploadFiles(fileWip: File, fileGSN: File): Observable<GradeLibraryVersion> {
		const formData = new FormData();
		if (fileWip) {
			formData.append('fileToUploadWip', fileWip);
		}

		if (fileGSN) {
			formData.append('fileToUploadGSN', fileGSN);
		}

		const headers = new HttpHeaders();
		headers.append('Content-Type', undefined);

		return this.httpClient.put<GradeLibraryVersion>('/api/datamanagement/gradelibrary/data', formData, { headers: headers });
	}
}